import { useCallback, useSyncExternalStore } from 'react';

const STORAGE_KEY = 'workforce-ui.icon-style';

export type IconStyle = 'image' | 'color';

const readIconStyle = (): IconStyle => (localStorage.getItem(STORAGE_KEY) === 'color' ? 'color' : 'image');

const listeners = new Set<() => void>();

const subscribe = (onStoreChange: () => void) => {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
};

const getSnapshot = () => readIconStyle();

const getServerSnapshot = (): IconStyle => 'image';

const emit = () => {
  for (const listener of listeners) {
    listener();
  }
};

export const useIconStyle = () => {
  const iconStyle = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const toggleIconStyle = useCallback(() => {
    const next: IconStyle = readIconStyle() === 'image' ? 'color' : 'image';
    localStorage.setItem(STORAGE_KEY, next);
    emit();
  }, []);

  return { iconStyle, toggleIconStyle };
};
